<template>
  <div>
    <div class="regular-price">
      {{ regularPriceLabel(pricing) }}
      <span v-if="isNonUSD" class="local-currency"> ({{ valueRange(pricing.min_price, pricing.max_price, localCurrencyCode) }}<sup>*</sup>)</span>
    </div>
    <div v-if="hasSalePrice" class="sale-price text-primary">
      {{ salePriceLabel(pricing) }}
      <span v-if="isNonUSD" class="local-currency"> ({{ valueRange(pricing.min_discount_price, pricing.max_discount_price, localCurrencyCode) }}<sup>*</sup>)</span>
    </div>
    <slot/>
  </div>
</template>

<style scoped>
i {
  font-size: small;
}
</style>

<script>
import { CurrencyMixin } from '../../mixins/CurrencyMixin'

export default {
    mixins: [CurrencyMixin],

    props: {
        hasSalePrice: {
            type: Boolean,
            default: false
        },
        pricing: {
            type: Object,
            default: null
        }
    },

    data () {
        return {
        }
    },

    methods: {
    },
}
</script>
